// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/ellipsis-vertical.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/ellipsis-vertical'

import { Icon, type IconComponentProps } from '../icon'

export const EllipsisVerticalIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
